import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { CreateJobAdmition, JobAdmition, EditJobAdmition } from "../../models/inModels/JobAdmition";

@Injectable()
export class JobAdmitionService {
  constructor(
        private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

    search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}/api/sales/admitions/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<JobAdmition> {
		return this.http.get(`${this.auth.apiUrl}/api/sales/admitions/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as JobAdmition)
			.catch(error => this.logging.handleError(error));
	}

	create(user: CreateJobAdmition): Promise<JobAdmition> {
		return this.http.post(`${this.auth.apiUrl}/api/sales/admitions/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as JobAdmition)
			.catch(error => this.logging.handleError(error));
	}

    update(user: EditJobAdmition): Promise<JobAdmition> {
		return this.http.post(`${this.auth.apiUrl}/api/sales/admitions/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as JobAdmition)
			.catch(error => this.logging.handleError(error));
	}

    delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}/api/sales/admitions/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
	
}



// WEBPACK FOOTER //
// ./src/app/services/business/job-admition.service.ts